import React, { useState } from "react";
import loadable from "@loadable/component";

import * as styles from "./Subscribe.module.scss";
const SubscribeModal = loadable(
  () => import("../SubscribeModal/SubscribeModal")
);
import { t, Trans } from "@lingui/macro";
import { InputForm } from "@silversea-ssc/ui-components-react";

const Subscribe: React.FC = () => {
  const [modalState, setModalState] = useState({
    isOpen: false,
    email: ""
  });

  return (
    <React.Fragment>
      <div className={styles.subscribe}>
        <div className={styles.title}>
          <label htmlFor="footer-subscribe-form">
            <Trans>
              Subscribe for exclusive <br />
              offers and news
            </Trans>
          </label>
        </div>
        <InputForm
          id="footer-subscribe-form"
          className={styles.form}
          placeholder={t`Your e mail address`}
          formAction="#"
          inputType="email"
          name="email"
          variant="transparent"
          icon="action"
          buttonVariant="white"
          dataContentPiece="sign_up_for_offers"
          onSubmitAction={(event) => {
            event.preventDefault();
            setModalState({
              isOpen: true,
              // eslint-disable-next-line @typescript-eslint/no-explicit-any
              email: (event.target as any).email.value
            });
          }}
        />
      </div>
      {modalState.isOpen && (
        <SubscribeModal
          email={modalState.email}
          isOpen={modalState.isOpen}
          onRequestClose={() =>
            setModalState({
              ...modalState,
              isOpen: false
            })
          }
        ></SubscribeModal>
      )}
    </React.Fragment>
  );
};

export default Subscribe;
